module.exports = function() {

  /**
   *  Validates the regular expression type.
   *
   *  @param cb The callback function.
   */
  this.main.regexp = function regexp(cb) {
    if(this.validates()) {
      this.required();
      this.type();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/regexp.js
// module id = 1379
// module chunks = 93